import { Component } from '@angular/core';
import { BreadcrumbNav, Breadcrumb, Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-breadcrumb-nav-skeleton',
  imports: [BreadcrumbNav, Breadcrumb, Skeleton],
  templateUrl: './breadcrumb-nav-skeleton.html',
})
export class BreadcrumbNavSkeleton {}
